export class Color {
    static mkWithKeyword(a, r, g, b, keyword) {
        const ret = new Color(a, r, g, b);
        ret.keyword = keyword;
        return ret;
    }
    static parse(keyword) {
        switch (keyword.toLowerCase()) {
            case 'aliceblue':
                return Color.AliceBlue;
            case 'antiquewhite':
                return Color.AntiqueWhite;
            case 'aqua':
                return Color.Aqua;
            case 'aquamarine':
                return Color.Aquamarine;
            case 'azure':
                return Color.Azure;
            case 'beige':
                return Color.Beige;
            case 'bisque':
                return Color.Bisque;
            case 'black':
                return Color.Black;
            case 'blanchedalmond':
                return Color.BlanchedAlmond;
            case 'blue':
                return Color.Blue;
            case 'blueviolet':
                return Color.BlueViolet;
            case 'brown':
                return Color.Brown;
            case 'burlywood':
                return Color.BurlyWood;
            case 'cadetblue':
                return Color.CadetBlue;
            case 'chartreuse':
                return Color.Chartreuse;
            case 'chocolate':
                return Color.Chocolate;
            case 'coral':
                return Color.Coral;
            case 'cornflowerblue':
                return Color.CornflowerBlue;
            case 'cornsilk':
                return Color.Cornsilk;
            case 'crimson':
                return Color.Crimson;
            case 'cyan':
                return Color.Cyan;
            case 'darkblue':
                return Color.DarkBlue;
            case 'darkcyan':
                return Color.DarkCyan;
            case 'darkgoldenrod':
                return Color.DarkGoldenrod;
            case 'darkgray':
                return Color.DarkGray;
            case 'darkgreen':
                return Color.DarkGreen;
            case 'darkkhaki':
                return Color.DarkKhaki;
            case 'darkmagenta':
                return Color.DarkMagenta;
            case 'darkolivegreen':
                return Color.DarkOliveGreen;
            case 'darkorange':
                return Color.DarkOrange;
            case 'darkorchid':
                return Color.DarkOrchid;
            case 'darkred':
                return Color.DarkRed;
            case 'darksalmon':
                return Color.DarkSalmon;
            case 'darkseagreen':
                return Color.DarkSeaGreen;
            case 'darkslateblue':
                return Color.DarkSlateBlue;
            case 'darkslategray':
                return Color.DarkSlateGray;
            case 'darkturquoise':
                return Color.DarkTurquoise;
            case 'darkviolet':
                return Color.DarkViolet;
            case 'deeppink':
                return Color.DeepPink;
            case 'deepskyblue':
                return Color.DeepSkyBlue;
            case 'dimgray':
                return Color.DimGray;
            case 'dodgerblue':
                return Color.DodgerBlue;
            case 'firebrick':
                return Color.Firebrick;
            case 'floralwhite':
                return Color.FloralWhite;
            case 'forestgreen':
                return Color.ForestGreen;
            case 'fuchsia':
                return Color.Fuchsia;
            case 'gainsboro':
                return Color.Gainsboro;
            case 'ghostwhite':
                return Color.GhostWhite;
            case 'gold':
                return Color.Gold;
            case 'goldenrod':
                return Color.Goldenrod;
            case 'gray':
                return Color.Gray;
            case 'green':
                return Color.Green;
            case 'greenyellow':
                return Color.GreenYellow;
            case 'honeydew':
                return Color.Honeydew;
            case 'hotpink':
                return Color.HotPink;
            case 'indianred':
                return Color.IndianRed;
            case 'indigo':
                return Color.Indigo;
            case 'ivory':
                return Color.Ivory;
            case 'khaki':
                return Color.Khaki;
            case 'lavender':
                return Color.Lavender;
            case 'lavenderblush':
                return Color.LavenderBlush;
            case 'lawngreen':
                return Color.LawnGreen;
            case 'lemonchiffon':
                return Color.LemonChiffon;
            case 'lightblue':
                return Color.LightBlue;
            case 'lightcoral':
                return Color.LightCoral;
            case 'lightcyan':
                return Color.LightCyan;
            case 'lightgoldenrodyellow':
                return Color.LightGoldenrodYellow;
            case 'lightgray':
            case 'lightgrey':
                return Color.LightGray;
            case 'lightgreen':
                return Color.LightGreen;
            case 'lightpink':
                return Color.LightPink;
            case 'lightsalmon':
                return Color.LightSalmon;
            case 'lightseagreen':
                return Color.LightSeaGreen;
            case 'lightskyblue':
                return Color.LightSkyBlue;
            case 'lightslategray':
                return Color.LightSlateGray;
            case 'lightsteelblue':
                return Color.LightSteelBlue;
            case 'lightyellow':
                return Color.LightYellow;
            case 'lime':
                return Color.Lime;
            case 'limegreen':
                return Color.LimeGreen;
            case 'linen':
                return Color.Linen;
            case 'magenta':
                return Color.Magenta;
            case 'maroon':
                return Color.Maroon;
            case 'mediumaquamarine':
                return Color.MediumAquamarine;
            case 'mediumblue':
                return Color.MediumBlue;
            case 'mediumorchid':
                return Color.MediumOrchid;
            case 'mediumpurple':
                return Color.MediumPurple;
            case 'mediumseagreen':
                return Color.MediumSeaGreen;
            case 'mediumslateblue':
                return Color.MediumSlateBlue;
            case 'mediumspringgreen':
                return Color.MediumSpringGreen;
            case 'mediumturquoise':
                return Color.MediumTurquoise;
            case 'mediumvioletred':
                return Color.MediumVioletRed;
            case 'midnightblue':
                return Color.MidnightBlue;
            case 'mintcream':
                return Color.MintCream;
            case 'mistyrose':
                return Color.MistyRose;
            case 'moccasin':
                return Color.Moccasin;
            case 'navajowhite':
                return Color.NavajoWhite;
            case 'navy':
                return Color.Navy;
            case 'oldlace':
                return Color.OldLace;
            case 'olive':
                return Color.Olive;
            case 'olivedrab':
                return Color.OliveDrab;
            case 'orange':
                return Color.Orange;
            case 'orangered':
                return Color.OrangeRed;
            case 'orchid':
                return Color.Orchid;
            case 'palegoldenrod':
                return Color.PaleGoldenrod;
            case 'palegreen':
                return Color.PaleGreen;
            case 'paleturquoise':
                return Color.PaleTurquoise;
            case 'palevioletred':
                return Color.PaleVioletRed;
            case 'papayawhip':
                return Color.PapayaWhip;
            case 'peachpuff':
                return Color.PeachPuff;
            case 'peru':
                return Color.Peru;
            case 'pink':
                return Color.Pink;
            case 'plum':
                return Color.Plum;
            case 'powderblue':
                return Color.PowderBlue;
            case 'purple':
                return Color.Purple;
            case 'red':
                return Color.Red;
            case 'rosybrown':
                return Color.RosyBrown;
            case 'royalblue':
                return Color.RoyalBlue;
            case 'saddlebrown':
                return Color.SaddleBrown;
            case 'salmon':
                return Color.Salmon;
            case 'sandybrown':
                return Color.SandyBrown;
            case 'seagreen':
                return Color.SeaGreen;
            case 'seashell':
                return Color.SeaShell;
            case 'sienna':
                return Color.Sienna;
            case 'silver':
                return Color.Silver;
            case 'skyblue':
                return Color.SkyBlue;
            case 'slateblue':
                return Color.SlateBlue;
            case 'slategray':
                return Color.SlateGray;
            case 'snow':
                return Color.Snow;
            case 'springgreen':
                return Color.SpringGreen;
            case 'steelblue':
                return Color.SteelBlue;
            case 'tan':
                return Color.Tan;
            case 'teal':
                return Color.Teal;
            case 'thistle':
                return Color.Thistle;
            case 'tomato':
                return Color.Tomato;
            case 'transparent':
                return Color.Transparent;
            case 'turquoise':
                return Color.Turquoise;
            case 'violet':
                return Color.Violet;
            case 'wheat':
                return Color.Wheat;
            case 'white':
                return Color.White;
            case 'whitesmoke':
                return Color.WhiteSmoke;
            case 'yellow':
                return Color.Yellow;
            case 'yellowgreen':
                return Color.YellowGreen;
            default:
                return undefined;
        }
    }
    get keyword() {
        return this.keyword_;
    }
    set keyword(value) {
        this.keyword_ = value;
    }
    // constructor with alpha and red, green, bluee components
    constructor(a, r, g, b) {
        this.a = a;
        this.r = r;
        this.g = g;
        this.b = b;
    }
    // opaque color
    static mkRGB(r, g, b) {
        return new Color(255, r, g, b);
    }
    /**  The color opaqueness: changes from 0 to 255 */
    get A() {
        return this.a;
    }
    set A(value) {
        this.a = value;
    }
    /** The red component: changes form 0 to 255 */
    get R() {
        return this.r;
    }
    /** The red component: changes form 0 to 255 */
    set R(value) {
        this.r = value;
    }
    /** The green component: changes form 0 to 255 */
    get G() {
        return this.g;
    }
    /** The red component: changes form 0 to 255 */
    set G(value) {
        this.g = value;
    }
    /** The blue component: changes form 0 to 255 */
    get B() {
        return this.b;
    }
    /** The blue component: changes form 0 to 255 */
    set B(value) {
        this.b = value;
    }
    static Xex(i) {
        const s = i.toString(16);
        if (s.length === 1) {
            return '0' + s;
        }
        return s.substring(s.length - 2, 2);
    }
    static equal(a, b) {
        return a.a === b.a && a.r === b.r && a.b === b.b && a.g === b.g;
    }
    // !=
    toString() {
        return this.keyword
            ? this.keyword
            : '"#' + Color.Xex(this.R) + Color.Xex(this.G) + Color.Xex(this.B) + (this.A === 255 ? '' : Color.Xex(this.A)) + '"';
    }
    //
    static get AliceBlue() {
        return Color.mkWithKeyword(255, 240, 248, 255, 'aliceblue');
    }
    //
    static get AntiqueWhite() {
        return Color.mkWithKeyword(255, 250, 235, 215, 'antiquewhite');
    }
    //
    static get Aqua() {
        return Color.mkWithKeyword(255, 0, 255, 255, 'aqua');
    }
    //
    static get Aquamarine() {
        return Color.mkWithKeyword(255, 127, 255, 212, 'aquamarine');
    }
    //
    static get Azure() {
        return Color.mkWithKeyword(255, 240, 255, 255, 'azure');
    }
    //
    static get Beige() {
        return Color.mkWithKeyword(255, 245, 245, 220, 'beige');
    }
    //
    static get Bisque() {
        return Color.mkWithKeyword(255, 255, 228, 196, 'bisque');
    }
    //
    static get Black() {
        return Color.mkWithKeyword(255, 0, 0, 0, 'black');
    }
    //
    static get BlanchedAlmond() {
        return Color.mkWithKeyword(255, 255, 235, 205, 'blanchedalmond');
    }
    //
    static get Blue() {
        return Color.mkWithKeyword(255, 0, 0, 255, 'blue');
    }
    //
    static get BlueViolet() {
        return Color.mkWithKeyword(255, 138, 43, 226, 'blueviolet');
    }
    //
    static get Brown() {
        return Color.mkWithKeyword(255, 165, 42, 42, 'brown');
    }
    //
    static get BurlyWood() {
        return Color.mkWithKeyword(255, 222, 184, 135, 'burlywood');
    }
    //
    static get CadetBlue() {
        return Color.mkWithKeyword(255, 95, 158, 160, 'cadetblue');
    }
    //
    static get Chartreuse() {
        return Color.mkWithKeyword(255, 127, 255, 0, 'chartreuse');
    }
    //
    static get Chocolate() {
        return Color.mkWithKeyword(255, 210, 105, 30, 'chocolate');
    }
    //
    static get Coral() {
        return Color.mkWithKeyword(255, 255, 127, 80, 'coral');
    }
    //
    static get CornflowerBlue() {
        return Color.mkWithKeyword(255, 100, 149, 237, 'cornflowerblue');
    }
    //
    static get Cornsilk() {
        return Color.mkWithKeyword(255, 255, 248, 220, 'cornsilk');
    }
    //
    static get Crimson() {
        return Color.mkWithKeyword(255, 220, 20, 60, 'crimson');
    }
    //
    static get Cyan() {
        return Color.mkWithKeyword(255, 0, 255, 255, 'cyan');
    }
    //
    static get DarkBlue() {
        return Color.mkWithKeyword(255, 0, 0, 139, 'darkblue');
    }
    //
    static get DarkCyan() {
        return Color.mkWithKeyword(255, 0, 139, 139, 'darkcyan');
    }
    //
    static get DarkGoldenrod() {
        return Color.mkWithKeyword(255, 184, 134, 11, 'darkgoldenrod');
    }
    //
    static get DarkGray() {
        return Color.mkWithKeyword(255, 169, 169, 169, 'darkgray');
    }
    //
    static get DarkGreen() {
        return Color.mkWithKeyword(255, 0, 100, 0, 'darkgreen');
    }
    //
    static get DarkKhaki() {
        return Color.mkWithKeyword(255, 189, 183, 107, 'darkkhaki');
    }
    //
    static get DarkMagenta() {
        return Color.mkWithKeyword(255, 139, 0, 139, 'darkmagenta');
    }
    //
    static get DarkOliveGreen() {
        return Color.mkWithKeyword(255, 85, 107, 47, 'darkolivegreen');
    }
    //
    static get DarkOrange() {
        return Color.mkWithKeyword(255, 255, 140, 0, 'darkorange');
    }
    //
    static get DarkOrchid() {
        return Color.mkWithKeyword(255, 153, 50, 204, 'darkorchid');
    }
    //
    static get DarkRed() {
        return Color.mkWithKeyword(255, 139, 0, 0, 'darkred');
    }
    //
    static get DarkSalmon() {
        return Color.mkWithKeyword(255, 233, 150, 122, 'darksalmon');
    }
    //
    static get DarkSeaGreen() {
        return Color.mkWithKeyword(255, 143, 188, 139, 'darkseagreen');
    }
    //
    static get DarkSlateBlue() {
        return Color.mkWithKeyword(255, 72, 61, 139, 'darkslateblue');
    }
    //
    static get DarkSlateGray() {
        return Color.mkWithKeyword(255, 47, 79, 79, 'darkslategray');
    }
    //
    static get DarkTurquoise() {
        return Color.mkWithKeyword(255, 0, 206, 209, 'darkturquoise');
    }
    //
    static get DarkViolet() {
        return Color.mkWithKeyword(255, 148, 0, 211, 'darkviolet');
    }
    //
    static get DeepPink() {
        return Color.mkWithKeyword(255, 255, 20, 147, 'deeppink');
    }
    //
    static get DeepSkyBlue() {
        return Color.mkWithKeyword(255, 0, 191, 255, 'deepskyblue');
    }
    //
    static get DimGray() {
        return Color.mkWithKeyword(255, 105, 105, 105, 'dimgray');
    }
    //
    static get DodgerBlue() {
        return Color.mkWithKeyword(255, 30, 144, 255, 'dodgerblue');
    }
    //
    static get Firebrick() {
        return Color.mkWithKeyword(255, 178, 34, 34, 'firebrick');
    }
    //
    static get FloralWhite() {
        return Color.mkWithKeyword(255, 255, 250, 240, 'floralwhite');
    }
    //
    static get ForestGreen() {
        return Color.mkWithKeyword(255, 34, 139, 34, 'forestgreen');
    }
    //
    static get Fuchsia() {
        return Color.mkWithKeyword(255, 255, 0, 255, 'fuchsia');
    }
    //
    static get Gainsboro() {
        return Color.mkWithKeyword(255, 220, 220, 220, 'gainsboro');
    }
    //
    static get GhostWhite() {
        return Color.mkWithKeyword(255, 248, 248, 255, 'ghostwhite');
    }
    //
    static get Gold() {
        return Color.mkWithKeyword(255, 255, 215, 0, 'gold');
    }
    //
    static get Goldenrod() {
        return Color.mkWithKeyword(255, 218, 165, 32, 'goldenrod');
    }
    //
    static get Gray() {
        return Color.mkWithKeyword(255, 128, 128, 128, 'gray');
    }
    //
    static get Green() {
        return Color.mkWithKeyword(255, 0, 128, 0, 'green');
    }
    //
    static get GreenYellow() {
        return Color.mkWithKeyword(255, 173, 255, 47, 'greenyellow');
    }
    //
    static get Honeydew() {
        return Color.mkWithKeyword(255, 240, 255, 240, 'honeydew');
    }
    //
    static get HotPink() {
        return Color.mkWithKeyword(255, 255, 105, 180, 'hotpink');
    }
    //
    static get IndianRed() {
        return Color.mkWithKeyword(255, 205, 92, 92, 'indianred');
    }
    //
    static get Indigo() {
        return Color.mkWithKeyword(255, 75, 0, 130, 'indigo');
    }
    //
    static get Ivory() {
        return Color.mkWithKeyword(255, 255, 255, 240, 'ivory');
    }
    //
    static get Khaki() {
        return Color.mkWithKeyword(255, 240, 230, 140, 'khaki');
    }
    //
    static get Lavender() {
        return Color.mkWithKeyword(255, 230, 230, 250, 'lavender');
    }
    //
    static get LavenderBlush() {
        return Color.mkWithKeyword(255, 255, 240, 245, 'lavenderblush');
    }
    //
    static get LawnGreen() {
        return Color.mkWithKeyword(255, 124, 252, 0, 'lawngreen');
    }
    //
    static get LemonChiffon() {
        return Color.mkWithKeyword(255, 255, 250, 205, 'lemonchiffon');
    }
    //
    static get LightBlue() {
        return Color.mkWithKeyword(255, 173, 216, 230, 'lightblue');
    }
    //
    static get LightCoral() {
        return Color.mkWithKeyword(255, 240, 128, 128, 'lightcoral');
    }
    //
    static get LightCyan() {
        return Color.mkWithKeyword(255, 224, 255, 255, 'lightcyan');
    }
    //
    static get LightGoldenrodYellow() {
        return Color.mkWithKeyword(255, 250, 250, 210, 'lightgoldenrodyellow');
    }
    //
    static get LightGray() {
        return Color.mkWithKeyword(255, 211, 211, 211, 'lightgray');
    }
    //
    static get LightGreen() {
        return Color.mkWithKeyword(255, 144, 238, 144, 'lightgreen');
    }
    //
    static get LightPink() {
        return Color.mkWithKeyword(255, 255, 182, 193, 'lightpink');
    }
    //
    static get LightSalmon() {
        return Color.mkWithKeyword(255, 255, 160, 122, 'lightsalmon');
    }
    //
    static get LightSeaGreen() {
        return Color.mkWithKeyword(255, 32, 178, 170, 'lightseagreen');
    }
    //
    static get LightSkyBlue() {
        return Color.mkWithKeyword(255, 135, 206, 250, 'lightskyblue');
    }
    //
    static get LightSlateGray() {
        return Color.mkWithKeyword(255, 119, 136, 153, 'lightslategray');
    }
    //
    static get LightSteelBlue() {
        return Color.mkWithKeyword(255, 176, 196, 222, 'lightsteelblue');
    }
    //
    static get LightYellow() {
        return Color.mkWithKeyword(255, 255, 255, 224, 'lightyellow');
    }
    //
    static get Lime() {
        return Color.mkWithKeyword(255, 0, 255, 0, 'lime');
    }
    //
    static get LimeGreen() {
        return Color.mkWithKeyword(255, 50, 205, 50, 'limegreen');
    }
    //
    static get Linen() {
        return Color.mkWithKeyword(255, 250, 240, 230, 'linen');
    }
    //
    static get Magenta() {
        return Color.mkWithKeyword(255, 255, 0, 255, 'magenta');
    }
    //
    static get Maroon() {
        return Color.mkWithKeyword(255, 128, 0, 0, 'maroon');
    }
    //
    static get MediumAquamarine() {
        return Color.mkWithKeyword(255, 102, 205, 170, 'mediumaquamarine');
    }
    //
    static get MediumBlue() {
        return Color.mkWithKeyword(255, 0, 0, 205, 'mediumblue');
    }
    //
    static get MediumOrchid() {
        return Color.mkWithKeyword(255, 186, 85, 211, 'mediumorchid');
    }
    //
    static get MediumPurple() {
        return Color.mkWithKeyword(255, 147, 112, 219, 'mediumpurple');
    }
    //
    static get MediumSeaGreen() {
        return Color.mkWithKeyword(255, 60, 179, 113, 'mediumseagreen');
    }
    //
    static get MediumSlateBlue() {
        return Color.mkWithKeyword(255, 123, 104, 238, 'mediumslateblue');
    }
    //
    static get MediumSpringGreen() {
        return Color.mkWithKeyword(255, 0, 250, 154, 'mediumspringgreen');
    }
    //
    static get MediumTurquoise() {
        return Color.mkWithKeyword(255, 72, 209, 204, 'mediumturquoise');
    }
    //
    static get MediumVioletRed() {
        return Color.mkWithKeyword(255, 199, 21, 133, 'mediumvioletred');
    }
    //
    static get MidnightBlue() {
        return Color.mkWithKeyword(255, 25, 25, 112, 'midnightblue');
    }
    //
    static get MintCream() {
        return Color.mkWithKeyword(255, 245, 255, 250, 'mintcream');
    }
    //
    static get MistyRose() {
        return Color.mkWithKeyword(255, 255, 228, 225, 'mistyrose');
    }
    //
    static get Moccasin() {
        return Color.mkWithKeyword(255, 255, 228, 181, 'moccasin');
    }
    //
    static get NavajoWhite() {
        return Color.mkWithKeyword(255, 255, 222, 173, 'navajowhite');
    }
    //
    static get Navy() {
        return Color.mkWithKeyword(255, 0, 0, 128, 'navy');
    }
    //
    static get OldLace() {
        return Color.mkWithKeyword(255, 253, 245, 230, 'oldlace');
    }
    //
    static get Olive() {
        return Color.mkWithKeyword(255, 128, 128, 0, 'olive');
    }
    //
    static get OliveDrab() {
        return Color.mkWithKeyword(255, 107, 142, 35, 'olivedrab');
    }
    //
    static get Orange() {
        return Color.mkWithKeyword(255, 255, 165, 0, 'orange');
    }
    //
    static get OrangeRed() {
        return Color.mkWithKeyword(255, 255, 69, 0, 'orangered');
    }
    //
    static get Orchid() {
        return Color.mkWithKeyword(255, 218, 112, 214, 'orchid');
    }
    //
    static get PaleGoldenrod() {
        return Color.mkWithKeyword(255, 238, 232, 170, 'palegoldenrod');
    }
    //
    static get PaleGreen() {
        return Color.mkWithKeyword(255, 152, 251, 152, 'palegreen');
    }
    //
    static get PaleTurquoise() {
        return Color.mkWithKeyword(255, 175, 238, 238, 'paleturquoise');
    }
    //
    static get PaleVioletRed() {
        return Color.mkWithKeyword(255, 219, 112, 147, 'palevioletred');
    }
    //
    static get PapayaWhip() {
        return Color.mkWithKeyword(255, 255, 239, 213, 'papayawhip');
    }
    //
    static get PeachPuff() {
        return Color.mkWithKeyword(255, 255, 218, 185, 'peachpuff');
    }
    //
    static get Peru() {
        return Color.mkWithKeyword(255, 205, 133, 63, 'peru');
    }
    //
    static get Pink() {
        return Color.mkWithKeyword(255, 255, 192, 203, 'pink');
    }
    //
    static get Plum() {
        return Color.mkWithKeyword(255, 221, 160, 221, 'plum');
    }
    //
    static get PowderBlue() {
        return Color.mkWithKeyword(255, 176, 224, 230, 'powderblue');
    }
    //
    static get Purple() {
        return Color.mkWithKeyword(255, 128, 0, 128, 'purple');
    }
    //
    static get Red() {
        return Color.mkWithKeyword(255, 255, 0, 0, 'red');
    }
    //
    static get RosyBrown() {
        return Color.mkWithKeyword(255, 188, 143, 143, 'rosybrown');
    }
    //
    static get RoyalBlue() {
        return Color.mkWithKeyword(255, 65, 105, 225, 'royalblue');
    }
    //
    static get SaddleBrown() {
        return Color.mkWithKeyword(255, 139, 69, 19, 'saddlebrown');
    }
    //
    static get Salmon() {
        return Color.mkWithKeyword(255, 250, 128, 114, 'salmon');
    }
    //
    static get SandyBrown() {
        return Color.mkWithKeyword(255, 244, 164, 96, 'sandybrown');
    }
    //
    static get SeaGreen() {
        return Color.mkWithKeyword(255, 46, 139, 87, 'seagreen');
    }
    //
    static get SeaShell() {
        return Color.mkWithKeyword(255, 255, 245, 238, 'seashell');
    }
    //
    static get Sienna() {
        return Color.mkWithKeyword(255, 160, 82, 45, 'sienna');
    }
    //
    static get Silver() {
        return Color.mkWithKeyword(255, 192, 192, 192, 'silver');
    }
    //
    static get SkyBlue() {
        return Color.mkWithKeyword(255, 135, 206, 235, 'skyblue');
    }
    //
    static get SlateBlue() {
        return Color.mkWithKeyword(255, 106, 90, 205, 'slateblue');
    }
    //
    static get SlateGray() {
        return Color.mkWithKeyword(255, 112, 128, 144, 'slategray');
    }
    //
    static get Snow() {
        return Color.mkWithKeyword(255, 255, 250, 250, 'snow');
    }
    //
    static get SpringGreen() {
        return Color.mkWithKeyword(255, 0, 255, 127, 'springgreen');
    }
    //
    static get SteelBlue() {
        return Color.mkWithKeyword(255, 70, 130, 180, 'steelblue');
    }
    //
    static get Tan() {
        return Color.mkWithKeyword(255, 210, 180, 140, 'tan');
    }
    //
    static get Teal() {
        return Color.mkWithKeyword(255, 0, 128, 128, 'teal');
    }
    //
    static get Thistle() {
        return Color.mkWithKeyword(255, 216, 191, 216, 'thistle');
    }
    //
    static get Tomato() {
        return Color.mkWithKeyword(255, 255, 99, 71, 'tomato');
    }
    //
    static get Transparent() {
        return Color.mkWithKeyword(0, 255, 255, 255, 'transparent');
    }
    //
    static get Turquoise() {
        return Color.mkWithKeyword(255, 64, 224, 208, 'turquoise');
    }
    //
    static get Violet() {
        return Color.mkWithKeyword(255, 238, 130, 238, 'violet');
    }
    //
    static get Wheat() {
        return Color.mkWithKeyword(255, 245, 222, 179, 'wheat');
    }
    //
    static get White() {
        return Color.mkWithKeyword(255, 255, 255, 255, 'white');
    }
    //
    static get WhiteSmoke() {
        return Color.mkWithKeyword(255, 245, 245, 245, 'whitesmoke');
    }
    //
    static get Yellow() {
        return Color.mkWithKeyword(255, 255, 255, 0, 'yellow');
    }
    //
    static get YellowGreen() {
        return Color.mkWithKeyword(255, 154, 205, 50, 'yellowgreen');
    }
}
//# sourceMappingURL=color.js.map